const ListPermission = {
  EN: {
    brand: {
      name: {
        createProject: 'Create project',
        viewProject: 'View projects',
        updateProject: 'Update project',
        deleteProject: 'Delete project',
        viewBrand: 'View brand',
        updateBrand: 'Update brand',
        deleteBrand: 'Delete brand',
        manageUsers: 'Manage users',
        createRole: 'Create role',
        viewRole: 'View roles',
        updateRole: 'Update role',
        deleteRole: 'Delete role',
      },
      description: {
        createProject: 'To create a project in brand',
        viewProject: 'To list projects and view their details',
        updateProject: 'To update project details',
        deleteProject: 'To delete a project in brand',
        viewBrand: 'To view brand details',
        updateBrand: 'To update brand details',
        deleteBrand: 'To delete a brand',
        manageUsers: 'To manage users in brand',
        createRole: 'To create a role in brand',
        viewRole: 'To list roles and view their details',
        updateRole: 'To update role details and permissions',
        deleteRole: 'To delete a role in brand',
      },
    },
    project: {
      name: {
        viewProject: 'View projects',
        deleteProject: 'Delete project',
        createZone: 'Create zone',
        viewZone: 'View zones',
        updateZone: 'Update zone',
        deleteZone: 'Delete zone',
        createDevice: 'Create device',
        viewDevice: 'View devices',
        updateDevice: 'Update device',
        deleteDevice: 'Delete device',
        createAsset: 'Create asset',
        viewAsset: 'View assets',
        viewPayment: 'View payments',
        useAsset: 'Use assets',
        updateAsset: 'Update asset',
        deleteAsset: 'Delete asset',
        createReservation: 'Create reservation',
        viewReservation: 'View reservation',
        updateReservation: 'Update reservation',
        updateProject: 'Update project',
        manageUsers: 'Manage users',
        createRole: 'Create role',
        viewRole: 'View roles',
        updateRole: 'Update role',
        deleteRole: 'Delete role',
        createResourceGroup: 'Create resource group',
        viewResourceGroup: 'View resource group',
        updateResourceGroup: 'Update resource group',
        deleteResourceGroup: 'Delete resource group',
        manageUserInResourceGroup: 'Manage users in resource group',
        forceOpenAsset: 'Force open asset',
        viewMeetings: 'View meetings',
        viewUsers: 'View users',
        chargesUpdate: 'Update charge ',
        chargesCreate: 'Create charges ',
        chargesDelete: 'Delete charges ',
        tenantResourcesView: 'Tenent resources view',
        tenantResourcesUpdate: 'Tenent resources update',
      },
      description: {
        viewProject: 'To list projects and view their details',
        deleteProject: 'To delete a project in brand',
        createZone: 'To create a zone in project',
        viewZone: 'To list zones and view their details',
        updateZone: 'To update zone details',
        deleteZone: 'To delete a zone in project',
        createDevice: 'To create a device in project',
        viewDevice: 'To list devices and view their details',
        updateDevice: 'To update device details',
        deleteDevice: 'To delete a device in project',
        createAsset: 'To create an asset in project',
        viewAsset: 'To list assets and view their details',
        viewPayment: 'To list payments and view their details',
        useAsset: 'To use all of assets in project',
        updateAsset: 'To update asset details',
        deleteAsset: 'To delete an asset in project',
        createReservation: 'To create a reservation in project',
        viewReservation: 'To list reservations and view their details',
        updateReservation: 'To update reservation details',
        updateProject: 'To update project details',
        manageUsers: 'To manage users in project',
        createRole: 'To create a role in project',
        viewRole: 'To list roles and view their details',
        updateRole: 'To update role details and permissions',
        deleteRole: 'To delete a role in project',
        createResourceGroup: 'To create a resource group in project',
        viewResourceGroup: 'To list resource groups and view their details',
        updateResourceGroup: 'To update resources and quota in group',
        deleteResourceGroup: 'To delete a resource group in project',
        manageUserInResourceGroup: 'To manage users in resource group',
        forceOpenAsset: 'To force open asset in project',
        viewMeetings: 'To view all meeting in project',
        viewUsers: 'To view all users in project',
        chargesUpdate: 'To update charge details ',
        chargesCreate: 'To create a charge in project',
        chargesDelete: 'To delete a charge in project',
        tenantResourcesView: 'To view all tenant resource',
        tenantResourcesUpdate: 'To update tenant resource',
      },
    },
    resource: {
      name: {
        viewAsset: 'View assets',
        useAsset: 'Use asset',
      },
      description: {
        viewAsset: 'To list assets and view their details',
        useAsset: 'To use an asset',
      },
    },
  },
  TH: {
    brand: {
      name: {
        createProject: 'สร้างโครงการ',
        viewProject: 'ดูโครงการ',
        updateProject: 'อัพเดทโครงการ',
        deleteProject: 'ลบโครงการ',
        viewBrand: 'ดูแบรนด์',
        updateBrand: 'อัพเดทแบรนด์',
        deleteBrand: 'ลบแบรนด์',
        manageUsers: 'จัดการผู้ใช้งาน',
        createRole: 'สร้างบทบาท',
        viewRole: 'ดูบทบาท',
        updateRole: 'อัพเดทบทบาท',
        deleteRole: 'ลบบทบาท',
      },
      description: {
        createProject: 'สามารถสร้างโครงการในแบรนด์ได้',
        viewProject: 'สามารถดูรายละเอียดของโครงการทั้งหมดได้',
        updateProject: 'สามารถอัพเดทรายละเอียดของโครงการได้',
        deleteProject: 'สามารถลบโครงการได้',
        viewBrand: 'สามารถดูรายละเอียดของแบรนด์ได้',
        updateBrand: 'สามารถอัพเดทรายละเอียดของแบรนด์ได้',
        deleteBrand: 'สามารถลบแบรนด์ได้',
        manageUsers: 'สามารถจัดการผู้ใช้งานในแบรนด์ได้',
        createRole: 'สามารถสร้างบทบาทในแบรนด์ได้',
        viewRole: 'สามารถดูรายละเอียดของบทบาททั้งหมดได้',
        updateRole: 'สามารถอัพเดทรายละเอียดของบทบาททั้งหมดได้',
        deleteRole: 'สามารถลบบทบาทได้',
      },
    },
    project: {
      name: {
        viewProject: 'ดูโครงการ',
        deleteProject: 'ลบโครงการ',
        createZone: 'สร้างโซน',
        viewZone: 'ดูโซน',
        updateZone: 'อัพเดทโซน',
        deleteZone: 'ลบโซน',
        createDevice: 'สร้างอุปกรณ์',
        viewDevice: 'ดูอุปกรณ์',
        updateDevice: 'อัพเดทอุปกรณ์',
        deleteDevice: 'ลบอุปกรณ์',
        createAsset: 'สร้างการใช้งาน',
        viewAsset: 'ดูการใช้งาน',
        viewPayment: 'ดูประวัติการจ่าย',
        updateAsset: 'อัพเดทการใช้งาน',
        deleteAsset: 'ลบการใช้งาน',
        useAsset: 'มีสิทธิใช้งาน',
        createReservation: 'สร้างการจอง',
        viewReservation: 'ดูการการจอง',
        updateReservation: 'อัพเดทการจอง',
        updateProject: 'อัพเดทโครงการ',
        manageUsers: 'จัดการผู้ใช้งาน',
        createRole: 'สร้างบทบาท',
        viewRole: 'ดูบทบาท',
        updateRole: 'อัพเดทบทบาท',
        deleteRole: 'ลบบทบาท',
        createResourceGroup: 'สร้างกลุ่มการใช้งาน',
        viewResourceGroup: 'ดูกลุ่มการใช้งาน',
        updateResourceGroup: 'อัพเดทกลุ่มการใช้งาน',
        deleteResourceGroup: 'ลบกลุ่มการใช้งาน',
        manageUserInResourceGroup: 'จัดการผู้ใช้งานในกลุ่มการใช้งาน',
        forceOpenAsset: 'บังคับให้เปิดอุปกรณ์',
        viewMeetings: 'ดูการประชุมทั้งหมด',
        viewUsers: 'ดูผู้ใช้งานทั้งหมด',
        chargesUpdate: 'อัพเดทค่าใช้จ่าย',
        chargesCreate: 'สร้างค่าใช้จ่าย',
        chargesDelete: 'ลบค่าใช้จ่าย',
      },
      description: {
        viewProject: 'สามารถดูรายละเอียดของโครงการทั้งหมดได้',
        deleteProject: 'สามารถลบโครงการได้',
        createZone: 'สามารถสร้างโซนในโครงการได้',
        viewZone: 'สามารถดูรายละเอียดของโซนทั้งหมดได้',
        updateZone: 'สามารถอัพเดทรายละเอียดของโซนได้',
        deleteZone: 'สามารถลบโซนในโครงการได้',
        createDevice: 'สามารถสร้างอุปกรณ์ในโครงการได้',
        viewDevice: 'สามารถดูรายละเอียดของอุปกรณ์ทั้งหมดได้',
        updateDevice: 'สามารถอัพเดทรายละเอียดของอุปกรณ์ได้',
        deleteDevice: 'สามารถลบอุปกรณ์ในโครงการได้',
        createAsset: 'สามารถสร้างการใช้งานในโครงการได้',
        viewAsset: 'สามารถดูรายละเอียดการใช้งานทั้งหมดได้',
        viewPayment: 'สามารถดูรายละเอียดการจ่ายได้',
        useAsset: 'สามารถใช้การใช้งานได้',
        updateAsset: 'สามารถอัพเดทรายละเอียดของการใช้งานได้',
        deleteAsset: 'สามารถลบการใช้งานได้',
        createReservation: 'สามารถสร้างการจองในโครงการได้',
        viewReservation: 'สามารถดูรายละเอียดการจองทั้งหมดได้',
        updateReservation: 'สามารถอัพเดทรายละเอียดการจองได้',
        updateProject: 'สามารถอัพเดทรายละเอียดโครงการได้',
        manageUsers: 'สามารถจัดการผู้ใช้งานในโครงการได้',
        createRole: 'สามารถสร้างบทบาทในโครงการได้',
        viewRole: 'สามารถดูรายละเอียดบทบาทในโครงการทั้งหมดได้',
        updateRole: 'สามารถอัพเดทรายละเอียดบทบาทในโครงการได้',
        deleteRole: 'สามารถลบบทบาทในโครงการได้',
        createResourceGroup: 'สามารถสร้างกลุ่มการใช้งานในโครงการได้',
        viewResourceGroup: 'สามารถดูรายละเอียดของกลุ่มการใช้งานได้',
        updateResourceGroup: 'สามารถอัพเดทการใช้งานและโควต้าในกลุ่มได้',
        deleteResourceGroup: 'สามารถลบกลุ่มการใช้งานในโครงการได้',
        manageUserInResourceGroup: 'สามารถจัดการผู้ใช้งานในกลุ่มการใช้งานได้',
        forceOpenAsset: 'สามารถบังคับให้เปิดอุปกรณ์ทั้งหมดได้',
        viewMeetings: 'สามารถดูการประชุมทั้งหมดได้',
        viewUsers: 'สามารถดูผู้ใช้งานทั้งหมดได้',
        chargesUpdate: 'สามารถอัพเดทการใช้งานค่าใช้จ่ายได้ในโครงการได้',
        chargesCreate: 'สามารถสร้างการใช้งานค่าใช้จ่ายในโครงการได้',
        chargesDelete: 'สามาถลบการใช้งานค่าใช้จ่ายในโครงการได้',
      },
    },
    resource: {
      name: {
        viewAsset: 'ดูการใช้งาน',
        useAsset: 'ใช้การใช้งาน',
      },
      description: {
        viewAsset: 'สามารถดูละเอียดการใช้งานทั้งหมดได้',
        useAsset: 'สามารถใช้การใช้งานได้',
      },
    },
  },
};

export default ListPermission;
